import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { translation } from '../../../../../../utils/helpers'

import Check from '../../../../../../shared/elements/check'

// Styles
import '../inputcomponents.scss'

class InputCheckbox extends PureComponent {

  constructor (props) {
    super(props)
    this.state = {
    }
    this.onInputChange = this.onInputChange.bind(this)
    this.onDisabledClick = this.onDisabledClick.bind(this)
  }
  onInputChange (e) {
    // console.log('[InputCheckbox] change', e.target.name, e.target.value, e.target.checked)
    this.props.onChange(e)
  }
  onDisabledClick (e) {
    if (this.props.disabled) {
      this.props.onDisabledClick(e)
    }
  }
  componentDidMount () {
  }
  render () {
    // const renderTitle = () => {
    //   let title = this.props.title
    //   if (!isNaN(Number(title))) title = translation(this.props.title)
    //   return (
    //     <label>{title}{this.props.icon}</label>
    //   )
    // }
    let value = this.props.name
    let checked = this.props.checked
    // let className = 'checkbox__custom ' + this.props.extraClassName

    let label = this.props.title
    if (!isNaN(Number(label))) label = translation(this.props.title)

    return (
      <Check
        id={value + '_input'}
        name={value}
        value='1'
        onChange={this.onInputChange}
        checked={checked === true}
        disabled={this.props.disabled}
        labelText={label}
      />
    )
    // return (
    //   <div className='inputcomponents__inner'>
    //     {renderTitle()}
    //     <div className={className}>
    //       <span onClick={this.onDisabledClick}>
    //         <input type='checkbox' id={value + '_input'} name={value} value='1' onChange={this.onInputChange} checked={checked === true} disabled={this.props.disabled} />
    //         <label htmlFor={value + '_input'} />
    //       </span>
    //     </div>
    //   </div>
    // )
  }
}

InputCheckbox.defaultProps = {
  icon: null,
  disabled: false,
  extraClassName: '',
  onChange: (e) => {
    console.log('todo')
  },
  onDisabledClick: () => {
    console.log('todo')
  },
  name: 'None',
  checked: false,
  title: 'nope'
}

InputCheckbox.propTypes = {
  icon: PropTypes.element,
  auth: PropTypes.object.isRequired
}

InputCheckbox.contextTypes = {
  // t: React.PropTypes.func.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}
export default connect(mapStateToProps, {
})(InputCheckbox)



// WEBPACK FOOTER //
// ./src/app/pages/Orders/Order/NewWorkCard/InputComponents/InputCheckbox/index.js